import { ActionType, IAction, IProxyParams } from '../../actions/types'

export function getURLfromAction(
  action: IAction,
  action_url: string = action?.action_url || action?.redirect_url || ''
) {
  return !action.aytm_domain ||
    action_url.startsWith('//') ||
    action_url.startsWith('https://') ||
    action_url.startsWith('http://')
    ? action_url
    : `${action.aytm_domain}${action_url}`
}

export function getProxyParamsFromUrl(action: IAction) {
  const proxy_params = {} as IProxyParams
  if (action.action == ActionType.REDIRECT && action.action_url) {
    const url = new URL(action.action_url)
    if (url && url.searchParams.get('aytm_list_token'))
      proxy_params['aytm_list_token'] = url.searchParams.get('aytm_list_token')
  }
  return proxy_params
}
